// extracted by mini-css-extract-plugin
export default {"PhotoTitleEditForm__submitBtn":"iy_a bhj_sq","PhotoTitleEditForm__cancelBtn":"iy_b bhj_su bhj_st"};